












































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import confirmDialog from '@/components/common/confirmDialog.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import courseEvaluation from '@/views/myFeedbacks/components/courseEvaluation.vue';
import { TrainClassDto, TrainingScheduling } from '@/api/models';
import classInfo from '@/components/common/classInfo.vue';
import problemList from './components/problemList.vue';
import moment from 'moment';
import { Dialog } from 'vant';

enum TypeEnum {
  已评分 = 0,
  待评分 = 1,
  培训中评分 = 2,
}

@Component({
  components: { confirmDialog, confirmFeedback, classInfo, courseEvaluation, problemList },
  //路由守卫
  beforeRouteEnter(to: any, from: any, next: any) {
    //全部日程页面回退
    if (from.name == 'schedule' || from.name == 'leave') {
      to.meta.isBack = true;
    }
    next();
  },
})
export default class TrainingDetail extends Vue {
  tabActive: string = 'schedule';
  courseOfType = TypeEnum.培训中评分;
  currentCourseData: any = {}; // 当前课程的数据
  //是否培训详情页(用于详情页展示完整标题)
  isDetail: boolean = true;
  trainStatus: string = '';
  title: string = '';
  loading: boolean = false;
  finished: boolean = false;
  dialogShow: boolean = false;
  feedbackShow: boolean = false;
  dialogType: string = '';
  feedbackType: string = '';
  successStatu: boolean = false;
  //报名
  bmDialogShow: boolean = false;
  bmDialogType: string = '';
  bmFeedbackShow: boolean = false;
  bmFeedbackType: string = '';
  bmSuccessStatu: boolean = false;
  //时间、地点签到确认框专用
  signTime: string = '';
  signAddress: string = '';
  attachmentList: any = [];
  schedule = {
    icon: require('@/images/schedule.png'),
  };
  trainingScheduling: TrainingScheduling[] = [];
  classItem: any = {
    id: '',
    className: '',
    deptName: '',
    address: '',
    trainType: '',
    days: 0,
    startClassDate: '',
    endClassDate: '',
    content: '',
    runClassType: '',
    objectScope: '',
    number: 0,
    schedulingAttachmentKey: '',
  };
  viewTrainingSchedules: TrainingScheduling[] = [];
  //课程数
  courseCounts: number = 0;
  //总学时
  totalHours: number = 0;
  isMore: boolean = false;

  deleteTrain(id: string) {
    this.$emit('delete-train', id);
  }

  //#region 全部日程
  getTrainingTime(item: any) {
    let trainingDate = moment(item.trainingDate).format('YYYY-MM-DD');
    let trainingStartTime = moment(item.trainingStartTime).format('HH:mm');
    let trainingEndTime = moment(item.trainingEndTime).format('HH:mm');
    let obj = { date: trainingDate, time: trainingStartTime + '-' + trainingEndTime };
    // let trainingTime = trainingDate + ' ' + trainingStartTime + '-' + trainingEndTime;
    return obj;
  }

  /**获取日程信息 */
  async findTrainingSchedules() {
    try {
      const data: any = await api.PlanOfClass.findTrainingSchedules_GET({ classId: this.classItem.id, tag: true });

      this.trainingScheduling = data.sort((a, b) => {
        const dateA: any = new Date(a.trainingDate);
        const dateB: any = new Date(b.trainingDate);

        // 首先比较 trainingDate
        if (dateA - dateB !== 0) {
          return dateA - dateB; // 按日期升序排序
        }

        // 如果日期相同，比较 trainingStartTime
        const timeA: any = new Date(a.trainingStartTime);
        const timeB: any = new Date(b.trainingStartTime);

        return timeA - timeB; // 按时间升序排序
      });
      // this.trainingScheduling = data;
    } catch (error) {
      console.log('error', error);
    }
  }

  toTeacherEvaluation(item: any) {
    let evaObj = {
      id: null,
      score: null,
      traineeId: '',
      trainingSchedulingId: '',
    };

    if (item.evaluation) evaObj = item.evaluation;

    this.currentCourseData = {
      ...evaObj,
      courseName: item.courseName,
      teacherName: item.teacher,
      teacherId: item.systemTeacherId,
      trainingSchedulingId: item.id,
      className: this.classItem.className,
      classType: this.classItem.classType,
      publicTrainingClassId: this.classItem.id,
      deptId: this.classItem.deptId,
    };

    let trainStartTime = new Date(item.trainingStartTime);
    let dateTimeNow = new Date();
    if (trainStartTime < dateTimeNow) {
      (this.$refs.courseRef as any).show = true;

      // this.$router.push({
      //   name: 'feedback',
      //   params: {
      //     feedbackTitle: '评价教师',
      //     teacherDetail: item,
      //     className: this.classItem.className,
      //     trainType: this.classItem.trainType,
      //   },
      // });
    } else {
      Dialog.alert({
        message: '当前课程还未开始，不能评价！',
      });
    }
  }

  toCourseEvaluation() {
    this.$router.push({
      name: 'myFeedbacks',
      params: { feedbackStatus: '教师评价' },
    });
  }

  courseCancel() {
    this.findTrainingSchedules();
  }
  //#endregion

  //钩子的触发顺序created-> mounted-> activated，退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated。
  async activated() {
    window.addEventListener('pagehide', this.onPageUnload);

    if (!this.$route.meta.isBack) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      if (this.$route.params.title) {
        this.title = this.$route.params.title;
        // sessionStorage.setItem('trainTitle', JSON.stringify(this.title));
      } else {
        let memoryTitle = sessionStorage.getItem('trainTitle');
        this.title = JSON.parse(memoryTitle!);
      }
      if (this.$route.params.trainStatus) {
        this.trainStatus = this.$route.params.trainStatus;
        // sessionStorage.setItem('trainStatus', JSON.stringify(this.trainStatus));
      } else {
        let memoryTrainStatus = sessionStorage.getItem('trainStatus');
        this.trainStatus = JSON.parse(memoryTrainStatus!);
      }
      if (this.$route.params.classItem) {
        this.classItem = JSON.parse(this.$route.params.classItem);
        // this.classItem =
        //   typeof this.$route.params.classItem === 'string'
        //     ? JSON.parse(this.$route.params.classItem)
        //     : this.$route.params.classItem;
        sessionStorage.setItem('trainClassItem', JSON.stringify(this.classItem));
        this.courseCounts = this.classItem?.trainingSchedulings?.length;
        this.findTrainingSchedules();
        this.classItem?.trainingSchedulings?.forEach((item: any) => {
          this.totalHours += item.hours;
        });
      } else {
        let trainingSchedulingData: any[] = JSON.parse(sessionStorage.getItem('trainingScheduling'));
        this.trainingScheduling = trainingSchedulingData;

        let memoryClassItem = sessionStorage.getItem('trainClassItem');
        this.classItem = JSON.parse(memoryClassItem!);
        this.courseCounts = this.classItem?.trainingSchedulings?.length;
      }

      //获取当前培训班学员报名审核状态
      if (this.classItem) {
        let solutionIds = [this.classItem.id];
        await this.getStudentAuditStatus(solutionIds, this.classItem);
      }
    }
    sessionStorage.setItem('trainTitle', JSON.stringify(this.title));
    sessionStorage.setItem('trainStatus', JSON.stringify(this.trainStatus));
    sessionStorage.setItem('trainClassItem', JSON.stringify(this.classItem));
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
  }
  //页面刷新
  onPageUnload() {
    sessionStorage.setItem('trainTitle', JSON.stringify(this.title));
    sessionStorage.setItem('trainStatus', JSON.stringify(this.trainStatus));
    sessionStorage.setItem('trainClassItem', JSON.stringify(this.classItem));
  }

  async mounted() {}

  //获取学员对应培训班的报名审核状态
  async getStudentAuditStatus(solutionIds: any, classItem: any) {
    const { data } = await api.ClassSolution.getStudentAuditStatus_GET({
      solutionIds: solutionIds,
    });
    if (data) {
      data.forEach((stuAuditItem: any) => {
        if (classItem.id == stuAuditItem.solutionId) {
          classItem.studentAuditStatu = stuAuditItem.studentAuditStatu;
        }
      });
    }
  }
  toScheduleDetail() {
    let trainingSchedulings = JSON.stringify(this.trainingScheduling);
    this.$router.push({
      name: 'schedule',
      params: {
        trainingSchedulings: trainingSchedulings,
      },
    });
  }

  onClickLeft() {
    this.$router.go(-1);
  }

  async onLoad() {
    this.getListData();
  }
  async getListData() {
    this.loading = true;
    try {
      const { data } = await api.ClassSolution.findClassSolutions_GET({});
      this.attachmentList = data!.items;
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
}
